import React from 'react';
import './header-column-max.scss';

export const HeaderColumnMax = () => {
    return <div className="header-columns-subject-wrapper" data-testid="header-columns-subject-wrapper">
        <div className="header-columns-subject">
            <div className="state-subjects">
                <div>Inbound</div>
                <div>Outbound</div>
            </div>
        </div>
    </div>;
};